import { NavLink, Link } from "react-router-dom";
import SVG from '../utility/Svg';
import React, {useState, useEffect} from 'react';

function HandleActiveNav(props) {
  return (
    <NavLink className={({ isActive, isPending }) => isPending ? props.classes + " pending" : isActive ? props.classes + " active" : props.classes } to={props.url}>{props.path}</NavLink>
  )
}

function Nav() {
  return (  
      <div className="container" style={{marginBottom: '30px'}}>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-lg-3">
            <Link className="navbar-brand" to="/">
              <SVG 
                width='200px'
                fill='none'
                stroke='#FFF'
              ></SVG>
            </Link>
          </div>
          <div className="col-xs-12 col-sm-6 col-lg-3">
            <h4 style={{ fontSize: '16px', color: '#fff'}}>Teaching Philosophy</h4>
            <ul>
              <li><HandleActiveNav classes="footer-item" url='/fundamentals' path='Fundamentals' /></li>
              <li><HandleActiveNav classes="footer-item" url='/theory' path='Music Theory' /></li>
              <li><HandleActiveNav classes="footer-item" url='/more' path='More than just scales' /></li>
              <li><HandleActiveNav classes="footer-item" url='/dream' path='Play the way you Dream of' /></li>
              <li><HandleActiveNav classes="footer-item" url='/levels' path='Beginner to Advanced...' /></li>
            </ul>
          </div>
          <div className="col-xs-12 col-sm-6 col-lg-3">
          <h4 style={{ fontSize: '16px', color: '#fff'}}>Additional Links</h4>
            <ul>
              <li>
                <HandleActiveNav classes="footer-item" url='/Booking' path='Booking a Lesson' />
              </li>
              <li>
                <HandleActiveNav classes="footer-item" url='/guitarcenter' path='Guitar Center Approved' />
              </li>
              <li>
                <HandleActiveNav classes="footer-item" url='/About' path='About' />
              </li>
              <li>
                <HandleActiveNav classes="footer-item" url='/Recommendations' path='Recommendations' />
              </li>
              <li>
                <HandleActiveNav classes="footer-item" url='/Privacy' path='Privacy' />
              </li>
            </ul>
            <h4 style={{ fontSize: '16px', color: '#fff' }}>Student Portal</h4>
              <ul>
                <li>
                  <HandleActiveNav classes="footer-item" url='/Login' path='Login' />
                </li>
                <li>
                  <HandleActiveNav classes="footer-item" url='/Portal' path='Dashboard' />
                </li>
                <li>
                  <HandleActiveNav classes="footer-item" url='/Lessons' path='Lesson Materials' />
                </li>
                <li>
                  <HandleActiveNav classes="footer-item" url='/Nigel' path='Nigel, The Guitar Guru' />
                </li>
              </ul>
          </div>
          <div className="footer-social col-xs-12 col-sm-6 col-lg-3">
              <div>
                <a href="https://www.youtube.com/@JasperQuartzGuitarAcademy" target="_blank" rel="noreferrer">
                  <img src="images/social/yt_logo_white_digital.png" alt="Jasper Quartz Guitar Academy YouTube Channel" style={{ width: '100%', height: 'auto', border: 0, maxWidth: '150px' }} />
                </a>
              </div>
          </div>
        </div>
      </div>
  );
}

export default Nav;
